// Constants
import { RECT_EDGES } from '../../../../../common/maths/geometry/rect/rectConstants';

/**
 * Determines the edges that
 * Requires either targetPoint or targetRect.
 * Will use targetPoint if both provided.
 */
export default ({ targetPoint, targetRect, layerRect }) => {
    const overflowEdges = [];

    const minY = targetPoint ? targetPoint.y : targetRect.top;
    const maxY = targetPoint ? targetPoint.y : targetRect.bottom;
    const minX = targetPoint ? targetPoint.x : targetRect.left;
    const maxX = targetPoint ? targetPoint.x : targetRect.right;

    if (minX < layerRect.left) overflowEdges.push(RECT_EDGES.left);
    if (maxX > layerRect.right) overflowEdges.push(RECT_EDGES.right);
    if (minY < layerRect.top) overflowEdges.push(RECT_EDGES.top);
    if (maxY > layerRect.bottom) overflowEdges.push(RECT_EDGES.bottom);

    return overflowEdges;
};
